'use strict';
define([], function () {
    function controller($scope, $element, $timeout, $state, $mdMedia, PlanDetailsService, LanguageService, $translate, $window) {
        var vm = $scope;
        var $ctrl = this;
        var stickyContexts = prepareStickyContext();
        var comparisonHeaderObserver = null;
        var numberFormatter = createNumberFormatter();
        var priceFormatter = createPriceFormatter();
        var language = getLanguage();
        var changePlanLabels = {
            it: 'Seleziona fino a 2 piani da confrontare',
            en: 'Select up to 2 plans to compare',
            es: 'Selecciona hasta 2 planes para comparar',
            pl: 'Wybierz do 2 planów do porównania',
            fr: 'Sélectionnez jusqu’à 2 forfaits à comparer',
            de: 'Bis zu 2 Pläne zum Vergleichen auswählen',
            pt: 'Selecione até 2 planos para comparar',
            fa: 'حداکثر ۲ طرح را برای مقایسه انتخاب کنید',
            zh: '最多选择 2 个方案进行比较',
            ja: '比較するプランを最大2つ選択'
        };

        vm.$mdMedia = $mdMedia;
        vm.changePlanLabel = changePlanLabels[language] || changePlanLabels.en;
        var currentPromo = PlanDetailsService.isPromoTime()
            ? PlanDetailsService.getCurrentPromo()
            : null;
        vm.currentPromo = currentPromo;
        vm.isPromoTime = !!currentPromo && currentPromo.promoType === 'all-platform-promo';
        vm.groupIcons = {
            platform: 'ti-layout-dashboard',
            seoAnalysis: 'ti-chart-histogram',
            seoCopywritingAssistant: 'ti-writing',
            ai: 'ti-sparkles',
            onSiteSeoAudit: 'ti-world-search',
            keywordResearch: 'ti-search',
            backlink: 'ti-link',
            positionMonitoring: 'ti-target-arrow',
            report: 'ti-report-analytics',
            leadGeneration: 'ti-users-group'
        };
        vm.featureGroups = [
            'platform',
            'seoAnalysis',
            'seoCopywritingAssistant',
            'ai',
            'onSiteSeoAudit',
            'keywordResearch',
            'backlink',
            'positionMonitoring',
            'report',
            'leadGeneration'
        ];

        vm.goToCheckout = goToCheckout;
        vm.getPrice = getPrice;
        vm.getPreviousPrice = getPreviousPrice;
        vm.hasPromoPrice = hasPromoPrice;
        vm.getFeatureValue = getFeatureValue;
        vm.formatNumber = formatNumber;
        vm.formatPrice = formatPrice;
        vm.isPlanAvailable = isPlanAvailable;
        vm.toggleMobilePlan = toggleMobilePlan;
        vm.isMobilePlanSelected = isMobilePlanSelected;
        vm.isMobilePlanDisabled = isMobilePlanDisabled;
        vm.mobilePlans = [];

        $scope.$watch(function () {
            return $ctrl.billingType;
        }, function (billingType) {
            vm.billingType = billingType;
        });

        $scope.$watch(function () {
            return $ctrl.canDoTrial;
        }, function (canDoTrial) {
            vm.canDoTrial = canDoTrial;
        });

        $scope.$watch(function () {
            return $ctrl.plans;
        }, function (plans) {
            if (!plans || !plans.length) {
                return;
            }
            vm.activePlansType = $ctrl.activePlansType;
            setPlans(plans);
        });

        $scope.$watch(function () {
            return $ctrl.activePlansType;
        }, function (activePlansType) {
            if (!activePlansType) {
                return;
            }
            vm.activePlansType = activePlansType;
            if (!vm.plans || !vm.plans.length) {
                setPlans(PlanDetailsService.getPlansByType(activePlansType));
            }
        });

        $timeout(setupCategoryStickyOffset, 0, false);

        $scope.$on('$destroy', function () {
            stickyContexts.forEach(function (element) {
                element.classList.remove('pricing-comparison-scroll-context');
            });
            if (comparisonHeaderObserver) {
                comparisonHeaderObserver.disconnect();
                comparisonHeaderObserver = null;
            }
        });

        function setPlans(nextPlans) {
            vm.billingType = $ctrl.billingType;
            vm.activePlansType = $ctrl.activePlansType;
            vm.canDoTrial = $ctrl.canDoTrial;
            vm.plans = nextPlans || [];
            var selectedNames = vm.mobilePlans.map(function (plan) {
                return plan.name;
            });
            vm.mobilePlans = vm.plans.filter(function (plan) {
                return selectedNames.indexOf(plan.name) !== -1;
            });
            vm.plans.forEach(function (plan) {
                if (vm.mobilePlans.length >= 2) {
                    return;
                }
                if (!isMobilePlanSelected(plan)) {
                    vm.mobilePlans.push(plan);
                }
            });
            vm.comparisonGroups = buildComparisonGroups(vm.plans);
            vm.comparisonGridStyle = {
                'grid-template-columns': 'minmax(220px, 1.15fr) repeat(' +
                    Math.max(vm.plans.length, 1) + ', minmax(0, 1fr))'
            };
            updateMobileComparisonGrid();
        }

        function toggleMobilePlan(plan) {
            if (!plan) {
                return;
            }
            var selectedIndex = vm.mobilePlans.map(function (item) {
                return item.name;
            }).indexOf(plan.name);
            if (selectedIndex >= 0) {
                if (vm.mobilePlans.length === 1) {
                    return;
                }
                vm.mobilePlans.splice(selectedIndex, 1);
            } else if (vm.mobilePlans.length < 2) {
                vm.mobilePlans.push(plan);
            }
            updateMobileComparisonGrid();
        }

        function isMobilePlanSelected(plan) {
            return vm.mobilePlans.some(function (selectedPlan) {
                return selectedPlan.name === plan.name;
            });
        }

        function isMobilePlanDisabled(plan) {
            return !isMobilePlanSelected(plan) && vm.mobilePlans.length >= 2;
        }

        function updateMobileComparisonGrid() {
            vm.mobileComparisonGridStyle = {
                'grid-template-columns': 'minmax(130px, 1.25fr) repeat(' +
                    Math.max(vm.mobilePlans.length, 1) + ', minmax(0, 1fr))'
            };
        }

        function buildComparisonGroups(plans) {
            var firstPlanFeatures = plans[0] && plans[0].features && plans[0].features[0];
            if (!firstPlanFeatures) {
                return [];
            }
            return vm.featureGroups.map(function (groupKey) {
                var source = firstPlanFeatures[groupKey] || {};
                var featureKeys = Object.keys(source);
                if (groupKey === 'platform' || groupKey === 'positionMonitoring') {
                    featureKeys = featureKeys.filter(function (featureKey) {
                        return featureKey !== 'websitesMonitorable';
                    });
                    if (groupKey === 'platform') {
                        var projectsIndex = featureKeys.indexOf('projects');
                        featureKeys.splice(projectsIndex >= 0 ? projectsIndex + 1 : featureKeys.length, 0, 'websitesMonitorable');
                    } else {
                        featureKeys.unshift('websitesMonitorable');
                    }
                }
                if (groupKey === 'onSiteSeoAudit') {
                    featureKeys = featureKeys.filter(function (featureKey) {
                        return featureKey !== 'websitesScannable';
                    });
                    featureKeys.unshift('websitesScannable');
                }
                return {
                    key: groupKey,
                    icon: vm.groupIcons[groupKey] || 'ti-circle-dot',
                    features: featureKeys.map(function (featureKey) {
                        return {
                            key: featureKey,
                            label: featureKey === 'crawlablePagesPerMonth'
                                ? 'crawl.credits.per.month'
                                : featureKey
                        };
                    })
                };
            }).filter(function (group) {
                return group.features.length;
            });
        }

        function getFeatureValue(plan, groupKey, featureKey) {
            var features = plan && plan.features && plan.features[0];
            var group = features && features[groupKey];
            var isDerivedWebsitesCount = featureKey === 'websitesMonitorable' || featureKey === 'websitesScannable';
            if (!group && !isDerivedWebsitesCount) {
                return '<span class="feature-value-text">—</span>';
            }
            var value = isDerivedWebsitesCount
                ? features && features.platform && features.platform.projects
                : group[featureKey];
            if (value === true) {
                return '<span class="feature-state feature-state--yes" role="img" aria-label="Included">' +
                    '<i class="ti ti-circle-check"></i></span>';
            }
            if (value === false) {
                return '<span class="feature-state feature-state--no" role="img" aria-label="Not included">' +
                    '<i class="ti ti-circle-minus"></i></span>';
            }
            if (value === null || typeof value === 'undefined' || value === '') {
                return '<span class="feature-value-text">—</span>';
            }
            if (typeof value === 'number' || /^-?\d+(?:[.,]\d+)?$/.test(String(value))) {
                return '<span class="feature-value-text">' + formatNumber(value) + '</span>';
            }
            return '<span class="feature-value-text">' + $translate.instant(String(value)) + '</span>';
        }

        function getPrice(plan) {
            if (!plan) {
                return 0;
            }
            var amount = vm.billingType === 'monthly' ? plan.monthlyAmount : plan.annualAmount;
            var decimal = vm.billingType === 'monthly' ? plan.monthlyAmountDecimal : plan.annualAmountDecimal;
            return Number(amount) + (Number(decimal || 0) / 100);
        }

        function formatNumber(value) {
            var numericValue = Number(value);
            return Number.isFinite(numericValue) ? numberFormatter.format(numericValue) : value;
        }

        function formatPrice(value) {
            var numericValue = Number(value);
            return Number.isFinite(numericValue) ? priceFormatter.format(numericValue) : value;
        }

        function getPreviousPrice(plan) {
            if (!plan) {
                return 0;
            }
            return vm.billingType === 'monthly'
                ? plan.monthlyAmountBeforePromo || plan.monthlyInsteadAmount || 0
                : plan.annualInsteadAmount || plan.monthlyAmount || 0;
        }

        function hasPromoPrice(plan) {
            if (!plan || !vm.isPromoTime || !currentPromo) {
                return false;
            }
            if (currentPromo.annualOnly && vm.billingType !== 'annually') {
                return false;
            }
            return getPreviousPrice(plan) > getPrice(plan);
        }

        function isPlanAvailable(plan) {
            return plan && (plan.name !== 'Lite' || !vm.isPromoTime);
        }

        function goToCheckout(plan) {
            var planAlias = vm.billingType === 'monthly' ? plan.monthlyAlias : plan.annualAlias;
            var checkoutParams = {alias: planAlias};
            var coupon = $window.localStorage.getItem('coupon');
            if (coupon) {
                checkoutParams.coupon = coupon;
            }
            $state.go('upgrade.checkout', checkoutParams);
        }

        function prepareStickyContext() {
            var contexts = [];
            var parent = $element[0].parentElement;
            while (parent) {
                if (parent.classList && (
                    parent.classList.contains('scroll-auto') ||
                    parent.classList.contains('st-upgrade-panel') ||
                    parent.classList.contains('pricing-container')
                )) {
                    parent.classList.add('pricing-comparison-scroll-context');
                    contexts.push(parent);
                }
                parent = parent.parentElement;
            }
            return contexts;
        }

        function setupCategoryStickyOffset() {
            var header = $element[0].querySelector('.comparison-head');
            if (!header) {
                return;
            }
            updateCategoryStickyOffset(header);
            if (typeof window.ResizeObserver === 'function') {
                comparisonHeaderObserver = new window.ResizeObserver(function () {
                    updateCategoryStickyOffset(header);
                });
                comparisonHeaderObserver.observe(header);
            }
        }

        function updateCategoryStickyOffset(header) {
            var top = header.offsetHeight + 'px';
            if (vm.categoriesStickyStyle && vm.categoriesStickyStyle.top === top) {
                return;
            }
            $scope.$evalAsync(function () {
                vm.categoriesStickyStyle = {
                    top: top
                };
            });
        }

        function getLanguage() {
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() ||
                (navigator.language || 'en-US');
            return String(locale).toLowerCase().split('-')[0];
        }

        function createNumberFormatter() {
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() ||
                (navigator.language || 'en-US');
            try {
                return new Intl.NumberFormat(locale, {useGrouping: 'always'});
            } catch (error) {
                return new Intl.NumberFormat('en-US');
            }
        }

        function createPriceFormatter() {
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() ||
                (navigator.language || 'en-US');
            try {
                return new Intl.NumberFormat(locale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            } catch (error) {
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }
        }
    }

    controller.$inject = ['$scope', '$element', '$timeout', '$state', '$mdMedia', 'PlanDetailsService', 'LanguageService', '$translate', '$window'];
    return {
        templateUrl: 'app/modules/upgrade/components/compare-plans/compare-plans.html',
        controller: controller,
        bindings: {
            plans: '<',
            activePlansType: '<',
            billingType: '=',
            canDoTrial: '<',
            onBillingTypeSwitch: '&'
        }
    };
});
